import React, {
    useRef,
    useEffect,
} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
    disableBodyScroll,
    clearAllBodyScrollLocks,
} from 'body-scroll-lock';

import XBig from 'app/assets/svg/x_big.component.svg';

import './modal.scss';


export default function Modal(props) {
    const {
        onClickClose,
        transitionState,
        title = '',
        children,
        appearEffect = 'moving',
        footerChildren = null,
        saveScrollContainerRef = () => {},
        info,
    } = props;

    const scrollContentRef = useRef(null);

    useEffect(() => {
        saveScrollContainerRef(scrollContentRef);
    }, []);

    useEffect(() => {
        if (scrollContentRef.current && transitionState !== 'exited') {
            disableBodyScroll(scrollContentRef.current);
        } else {
            clearAllBodyScrollLocks();
        }
    }, [transitionState]);

    const modalClasses = classNames({
        modal: true,
        [transitionState]: transitionState,
        [appearEffect]: appearEffect,
    });

    const modalWrapClasses = classNames({
        'modal-wrap': true,
        [appearEffect]: appearEffect,
        info: [info],
    });

    const modalContentClasses = classNames({
        'modal-content': true,
        [transitionState]: transitionState,
        [appearEffect]: appearEffect,
    });

    const isOpen = transitionState !== 'exited';

    return (
        <div styleName={modalClasses}>
            <div styleName={modalWrapClasses}>
                {appearEffect !== 'blurring' && (
                    <div styleName="modal-header">
                        <p styleName="modal-header__text">
                            {title}
                        </p>
                        <button
                            type="button"
                            onClick={onClickClose}
                            styleName="modal-close"
                        >
                            <XBig />
                        </button>
                    </div>
                )}

                {appearEffect === 'blurring' && (
                    <button
                        type="button"
                        onClick={onClickClose}
                        styleName="modal-close-blurring"
                    />
                )}

                <div styleName={modalContentClasses} ref={scrollContentRef}>
                    <div styleName="modal-content-content">
                        {children}
                    </div>
                </div>
                {/* {isOpen && (
                    <ScrollLock
                        touchScrollTarget={scrollContentRef.current}
                    />
                )} */}
            </div>
            {footerChildren && (
                <div styleName="modal-footer">
                    {footerChildren}
                </div>
            )}
        </div>
    );
}

Modal.propTypes = {
    transitionState: PropTypes.string.isRequired,
    onClickClose: PropTypes.func.isRequired,
    title: PropTypes.string,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
    footerChildren: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]),

    saveScrollContainerRef: PropTypes.func,

    appearEffect: PropTypes.oneOf(['blurring', 'moving']),
};
